import { MODE } from "../api/static.data.pnp"

export const checkDomain = () => {
    if (MODE === "DEV") {
        const searchParams = new URLSearchParams(window.location.search);
        const domain = searchParams.get('domain');
        return domain === "chat" ? domain : "app";
    }
    if (MODE === "PROD") {
        const hostname = window.location.hostname;
        if (hostname.includes('chat')) {
            return 'chat';
        } else if (hostname.includes('app')) {
            return 'app';
        } else {
            return 'app';
        }
    }
}